import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { ApiFailureError } from '../../../lib/http/errors';
import { useApiClient } from '../../session/client';
import { previewSchema, type InvitationPreview } from './schemas';

export function useInvitationPreview(
  token: string | null,
  enabled: boolean,
): UseQueryResult<InvitationPreview, ApiFailureError> {
  const client = useApiClient();

  return useQuery<InvitationPreview, ApiFailureError>({
    queryKey: ['invitation-preview', token],
    queryFn: () => client.postParsed('/invitations/preview', { token }, previewSchema),
    enabled: token !== null && enabled,
    retry: false,
    // Retaining the key on the app-wide cache would outlive the screen and leak the bearer credential.
    gcTime: 0,
  });
}
